/* rc-video — reveal + play on click, plus a Safari/Mac autoplay kick. Event-delegated +
   idempotent. Load once, defer. */
(function () {
  if (window.__rcVideoInit) return;
  window.__rcVideoInit = true;

  /* Click-to-play (poster + red button → inject the real <video>/<iframe> and play). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rc-video__play');
    if (!btn) return;
    var wrap = btn.closest('[data-rc-video]');
    if (!wrap) return;
    var tpl = wrap.querySelector('[data-rc-video-template]');
    var frame = wrap.querySelector('.rc-video__frame');
    if (!tpl || !frame) return;
    frame.appendChild(tpl.content.cloneNode(true));
    wrap.classList.add('is-playing');
    var vid = frame.querySelector('video');
    if (vid) { try { vid.play(); } catch (err) {} }
  });

  /* Autoplay kick — Safari on Mac can ignore the `autoplay` attribute (notably with <source>
     children, lazy load, or before the element is on screen). Explicitly mute + play, and retry
     when the data is ready and when the video scrolls into view. Muted-autoplay is always allowed,
     so this is safe; the only thing it can't beat is macOS Low Power Mode. */
  function kick(v) {
    try { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }
  function initAutoplay() {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) kick(en.target); });
    }, { threshold: 0.15 }) : null;
    Array.prototype.forEach.call(vids, function (v) {
      kick(v);
      v.addEventListener('loadeddata', function () { kick(v); }, { once: true });
      if (io) io.observe(v);
    });
    /* Belt-and-braces for strict autoplay blocking (notably iOS Low Power Mode): play on first tap. */
    function onFirst() {
      Array.prototype.forEach.call(document.querySelectorAll('video[autoplay]'), kick);
      document.removeEventListener('touchstart', onFirst);
      document.removeEventListener('click', onFirst);
    }
    document.addEventListener('touchstart', onFirst, { passive: true });
    document.addEventListener('click', onFirst);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAutoplay);
  else initAutoplay();
})();
